var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"800px"}},[_c('ImageMockup',{attrs:{"mockup-img-src":require('@/assets/images/sandbox/poster_mockup.png'),"product-image-corners":[
            [0.3687368737, 0.0888088809],
            [0.750975, 0.0657065707],
            [0.7557755776, 0.7356735674],
            [0.3717371737, 0.7248735374],
        ]}},[_c('PrintPreview',{attrs:{"use-aspect-ratio":false}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }